import { createModule } from '@dynapp/wc-api-generic'

// TODO: We should store as UTC
function parseDateStr (dateStr) {
  const [datePart, timePart] = dateStr.split(' ');
  const [year, month, date] = datePart.split('-');
  const timeParts = timePart.split(':');
  var hour, minute, second;
  if (timeParts.length == 2) {
    [hour, minute] = timeParts;
    second = '00';
  } else {
    [hour, minute, second] = timeParts;
  }

  return new Date(year, month - 1, date, hour, minute, second);
}

export default createModule({
  entitySingular: 'publication',
  entityPlural: 'publications',
  dataObject: 'dync-appshop-web',
  mode: process.env.NODE_ENV,
  getters: {
    latest (state) {
      if (!state.items || state.items.length === 0)
        return null;

      const updatedAt = state.items.map(i => parseDateStr(i.updated_at));
      return Math.max.apply(null, updatedAt);
    },
    hasChangesSincePublish (state, getters, rootState, rootGetters) {
      if (rootGetters.isLoadingFor('publications.read')) {
        return false;
      }
      const latestPublish = getters.latest;
      const relevantModules = Object.keys(rootState).filter(m => rootState[m].publishable);

      return relevantModules.some(m => {
        if (!rootState[m].items || rootState[m].items.length === 0)
          return false;

        // A publishable item exists and nothing has been published.
        // We can publish that.
        if (!latestPublish)
          return true;

        return rootState[m].items.some(item => {
          if (!item.updated_at)
            return false;
          const changedDate = parseDateStr(item.updated_at);
          return changedDate > latestPublish;
        });
      });
    }
  },
  actions: {
    publish ({dispatch}) {
      return dispatch('createItem', {
        callback: 'dync-appshop-publish'
      });
    }
  }
});
